"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BestLabel = _interopRequireDefault(require("./BestLabel"));
var _RequiredInputWithLabel = _interopRequireDefault(require("../required/RequiredInputWithLabel"));
var _RequiredInput = _interopRequireDefault(require("../required/RequiredInput"));
var _Input = _interopRequireDefault(require("./Input"));
var _TextArea = _interopRequireDefault(require("./TextArea"));
var _DatePickerInput = _interopRequireDefault(require("../dates/DatePickerInput"));
var _BestSelect = _interopRequireDefault(require("./BestSelect"));
var _CurrencyInput = _interopRequireDefault(require("./CurrencyInput"));
var _NumberInput = _interopRequireDefault(require("./NumberInput"));
var _FormatterHelper = require("../../../components/helpers/FormatterHelper");
var _DateTimePickerInput = _interopRequireDefault(require("../dates/DateTimePickerInput"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var FormInput = function FormInput(_ref) {
  var type = _ref.type,
    name = _ref.name,
    value = _ref.value,
    onChangeFn = _ref.onChangeFn,
    options = _ref.options,
    isDisabled = _ref.isDisabled,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    isRequired = _ref.isRequired,
    timeZone = _ref.timeZone,
    label = _ref.label,
    formatter = _ref.formatter,
    editable = _ref.editable,
    placeholder = _ref.placeholder,
    inputStyle = _ref.inputStyle,
    rest = _objectWithoutProperties(_ref, ["type", "name", "value", "onChangeFn", "options", "isDisabled", "minDate", "maxDate", "isRequired", "timeZone", "label", "formatter", "editable", "placeholder", "inputStyle"]);

  // Get the correct input given the type
  var getInput = function getInput() {
    switch (type) {
      case "date":
        return _react["default"].createElement(_DatePickerInput["default"], _extends({
          id: name,
          value: value,
          minDate: minDate,
          maxDate: maxDate,
          onChange: onChangeFn,
          timeZone: timeZone,
          disabled: isDisabled
        }, rest));
      case "datetime":
        return _react["default"].createElement(_DateTimePickerInput["default"], {
          id: name,
          value: value,
          minDate: minDate,
          maxDate: maxDate,
          onChange: onChangeFn,
          timeZone: timeZone,
          disabled: isDisabled
        });
      case "select":
        // If select is required and has no value, then give invalid highlight
        var className = isRequired && (!value || value.label === "") ? "is-invalid" : "";
        return _react["default"].createElement(_BestSelect["default"], {
          className: className,
          id: name,
          value: value,
          options: options,
          onChange: onChangeFn,
          isDisabled: isDisabled
        });
      case "currency":
        return _react["default"].createElement(_CurrencyInput["default"], {
          id: name,
          value: value,
          onChange: onChangeFn,
          disabled: isDisabled
        });
      case "textarea":
        return _react["default"].createElement(_TextArea["default"], {
          id: name,
          onChange: onChangeFn,
          disabled: isDisabled,
          value: value
        });
      case "number":
        return _react["default"].createElement(_NumberInput["default"], {
          id: name,
          value: value === null ? "" : value,
          onChange: onChangeFn,
          disabled: isDisabled
        });
      default:
        // Standard text input
        return _react["default"].createElement(_Input["default"], {
          id: name,
          onChange: function onChange(event) {
            onChangeFn(event.target.value);
          },
          value: value === null ? "" : value,
          disabled: isDisabled,
          placeholder: placeholder,
          inputStyle: inputStyle
        });
    }
  }; // Label an item (text, or an input field)

  var LabelledItem = function LabelledItem(_ref2) {
    var label = _ref2.label,
      show = _ref2.show,
      name = _ref2.name;
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_BestLabel["default"], {
      htmlFor: name
    }, label), _react["default"].createElement("div", null, show));
  };
  var UnlabeledItem = function UnlabeledItem(_ref3) {
    var show = _ref3.show;
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", null, show));
  };
  var renderEdit = function renderEdit() {
    var input = getInput();
    var labelExists = label != null && label != "";
    if (isRequired && labelExists) {
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_RequiredInputWithLabel["default"], {
        name: name,
        label: label
      }, input));
    }
    if (isRequired && !labelExists) {
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_RequiredInput["default"], {
        name: name
      }, input));
    } else if (labelExists) {
      return LabelledItem({
        label: label,
        show: input,
        name: name
      });
    } else {
      return UnlabeledItem({
        show: input
      });
    }
  };
  var getDisplayValue = function getDisplayValue() {
    // If given dropdown item, show the label
    if (!value) {
      return null;
    }
    var val = type === "select" ? value.label : value;
    var Formatter = (0, _FormatterHelper.getFormatter)(formatter, {
      value: val
    });
    return Formatter || val;
  };
  var renderView = function renderView() {
    var valueToShow = getDisplayValue();
    return LabelledItem({
      label: label,
      show: valueToShow,
      name: name
    });
  };
  return _react["default"].createElement("div", {
    className: "form-group"
  }, editable ? renderEdit() : renderView());
};
FormInput.defaultProps = {
  type: "text",
  editable: false,
  isRequired: false,
  options: [],
  isDisabled: false,
  show: true,
  onChangeFn: function onChangeFn() {},
  placeholder: "",
  formatter: null,
  minDate: null,
  maxDate: null,
  timeZone: "",
  inputStyle: {}
};
FormInput.propTypes = {
  /** Type of the input */
  type: _propTypes["default"].string,
  /** Name of the input */
  name: _propTypes["default"].string.isRequired,
  /** label of the input */
  label: _propTypes["default"].any.isRequired,
  /** value of the input */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].instanceOf(Date), _propTypes["default"].object, _propTypes["default"].array]).isRequired,
  /** on change function */
  onChangeFn: _propTypes["default"].func,
  /** if the input is required */
  isRequired: _propTypes["default"].bool,
  /** If the input is editable */
  editable: _propTypes["default"].bool,
  /** if the input is disabled */
  isDisabled: _propTypes["default"].bool,
  /** Options for the select types */
  options: _propTypes["default"].array,
  /** placeholder of the input */
  placeholder: _propTypes["default"].string,
  /** formatter for the input */
  formatter: _propTypes["default"].any,
  /** min date for the date type*/
  minDate: _propTypes["default"].object,
  /** max date for the date type */
  maxDate: _propTypes["default"].object,
  /** timezone for the date type */
  timeZone: _propTypes["default"].string,
  /** optional input style override */
  inputStyle: _propTypes["default"].object,
  /** to show the input or not */
  show: _propTypes["default"].bool
};
var _default = FormInput;
exports["default"] = _default;